import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import CommentsWrap from '@/components/comments_components/CommentsWrap';
import RequiredIndicator from '@/components/common/RequiredIndicator';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import { QuestionProps } from '@/models/Question';

function CheckboxQuestion({ question }: { question: QuestionProps }) {
  const { makingApiRequest, canEdit, answers, saveApplicationAnswer2 } =
    useContext(CurrentApplicationContext);

  const questionAnswer = answers[question.id];

  const [checked, setChecked] = useState<boolean>(
    questionAnswer?.responseInt === 1 || questionAnswer?.responseString === '1'
  );

  async function handleChanged(_event: React.ChangeEvent<HTMLInputElement>, inputChecked: boolean) {
    const answer = inputChecked ? 1 : question.questionNeeded ? null : 0;

    await saveApplicationAnswer2(question, answer);
    setChecked(inputChecked);
  }

  return (
    <Box display='flex' width='100%' justifyContent='space-between' alignItems='start'>
      <Box
        display='flex'
        flexDirection={'column-reverse'}
        alignItems='left'
        justifyContent='flex-start'
      >
        <FormControlLabel
          sx={{ marginTop: '10px' }}
          control={<Checkbox disabled={!canEdit || makingApiRequest} onChange={handleChanged} />}
          label={question.questionNote}
          checked={checked}
        />

        <Typography variant='adfBody1' sx={{ marginBottom: '8px' }}>
          {`${question.questionText} `}
          {question?.questionNeeded ? <RequiredIndicator /> : ''}
        </Typography>
      </Box>
      <CommentsWrap question={question} />
    </Box>
  );
}

export default CheckboxQuestion;
